import { render, staticRenderFns } from "./InvoicePrint.vue?vue&type=template&id=58f22ad2&scoped=true&"
import script from "./InvoicePrint.vue?vue&type=script&lang=js&"
export * from "./InvoicePrint.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePrint.vue?vue&type=style&index=0&id=58f22ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f22ad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VContainer,VIcon,VSheet})
